import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Exam } from "./interfaces/exams.service/types";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SignatureService {
  public examUnSigned$: Subject<any> = new Subject<any>();
  public alertToSign$: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient) {}

  isExamSigned(exam: Exam): boolean {
    const isDraft = exam?.Draft;
    const signedBy = exam?.SignedBy;
    const signedDate = exam?.SignedDate;

    if (!isDraft && signedBy && signedDate) {
      return true;
    }

    return false;
  }

  async unSignExam(examId: number) {
    const data = {
      isDraft: true,
      signedBy: null,
      signedDate: null,
      closedDate: null,
    };

    try {
      return this.http.post(`/api/newExams/signature/un-sign/${examId}`, data);
    } catch (error) {
      console.log(error);
    }
  }
}
